import { clsx, type ClassValue } from 'clsx';

/**
 * Tailwind className combiner. Thin wrapper over clsx so every UI component
 * merges conditional classes consistently.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
